import { FC } from "react";
import { useTranslation } from "react-i18next";
import { EditProgram, Media, MediaFolder, Program } from "../../../../types";
import {
  Modal,
  ModalBody,
  ModalClose,
  ModalHeader,
  ModalTitle,
} from "../../../UI/Modal";
import ProgramForm from "../ProgramForm";

type Props = {
  program?: Program;
  isOpen: boolean;
  isSubmitting: boolean;
  medias: Media[];
  onClose: () => void;
  onSubmit: (data: EditProgram) => void;
  onChangeFolder: (folderId: MediaFolder["projectId"]) => void;
};

const ProgramModal: FC<Props> = ({
  program,
  isOpen,
  isSubmitting,
  medias,
  onClose,
  onSubmit,
  onChangeFolder,
}) => {
  const { t } = useTranslation();

  return (
    <Modal show={isOpen} onClose={() => {}}>
      <ModalHeader>
        <ModalTitle>
          {!program
            ? t("components.common.programModal.typeNew")
            : t("components.common.programModal.typeEdit")}
        </ModalTitle>
        <ModalClose onClose={onClose}>x</ModalClose>
      </ModalHeader>
      <ModalBody>
        <ProgramForm
          isSubmitting={isSubmitting}
          editable
          isAdmin
          onSubmit={(data: any) => onSubmit(data)}
          validable={false}
          onCancel={onClose}
          program={program}
          onChangeFolder={onChangeFolder}
          medias={medias}
        />
      </ModalBody>
    </Modal>
  );
};

export default ProgramModal;
